import $ from 'jquery';

export default class Helper {
  static showGlobalMessage(message, error) {
    if (error) {
      if (!$('.global-message').hasClass('error'))
        $('.global-message').addClass('error');
      $('.global-message').fadeIn();
      message = `<i class="fas fa-exclamation-triangle mr-2"></i>${message}`;
    } else {
      $('.global-message').removeClass('error');
      $('.global-message').fadeIn();
      setTimeout(function() {
        $('.global-message').fadeOut();
      }, 8000);
      message = `<i class="fas fa-check-square mr-2"></i>${message}`;
    }

    $('.global-message').html(message);
  }

  static qs(name) {
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null
      ? ''
      : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  static setSaveState(isSaving, el) {
    if ($(el).data('class')) {
      el = $(`.${$(el).data('class')}`);
    }

    if (isSaving) {
      $(el).html(
        `<span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>${$(
          el
        ).data('active')}...`
      );
      $('.a-btn').prop('disabled', true);
      $('.a-btn--delete').toggleClass('disabled');
    } else {
      $(el).html($(el).data('default'));
      $('.a-btn').prop('disabled', false);
      $('.a-btn--delete').toggleClass('disabled');
    }
  }

  static getIndex(key) {
    switch (key) {
      case 'courses':
        return process.env.ALGOLIA_COURSES_INDEX;
      case 'faculty':
        return process.env.ALGOLIA_FACULTY_INDEX;
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/Helpers.js